<div class="id_pw_find">
  <a class="btn_reg" *ngIf="l_state!==1" (click)="changeState(1)" ><!--{{ 'Login' | translate }}-->로그인</a>
  <a class="btn_reg" [routerLink]="['/kr/signup']"><!--{{ 'Register' | translate }}-->회원가입</a>
  <a class="btn_reg" *ngIf="l_state!==2" (click)="changeState(2)"><!--{{ 'Forgot ID' | translate }}-->아이디 찾기</a>
  <a class="btn_reg" *ngIf="l_state!==3" (click)="changeState(3)"><!--{{ 'Forgot Password' | translate }}-->비밀번호 찾기</a>
</div>